import { HttpClient, HttpHeaders } from '@angular/common/http';
import { config } from 'src/app/app.config';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SearchService = /** @class */ (function () {
    function SearchService(http) {
        var _this = this;
        this.http = http;
        this.query = new BehaviorSubject('');
        this.currentPage = 0;
        this.searchResult = new Subject();
        this.total = 0;
        this.responseHandler = function (res) {
            _this.total = res.totalResultCount;
            _this.searchResult.next(res.items);
        };
        this.query.subscribe(function (query) {
            if (query) {
                _this.search({ query: query, page: _this.currentPage }).subscribe(_this.responseHandler);
            }
        });
        this.headers = new HttpHeaders({
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        });
    }
    SearchService.prototype.searchBy = function (query) {
        this.resetCurrentPage();
        this.query.next(query);
    };
    SearchService.prototype.changePageTo = function (page) {
        this.currentPage = page;
        this.query.next(this.query.value);
    };
    SearchService.prototype.resetCurrentPage = function () {
        this.currentPage = 0;
    };
    SearchService.prototype.search = function (params) {
        return this.http.post(config.searchApi + 'search', params, { headers: this.headers });
    };
    SearchService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SearchService_Factory() { return new SearchService(i0.ɵɵinject(i1.HttpClient)); }, token: SearchService, providedIn: "root" });
    return SearchService;
}());
export { SearchService };
